import React, {Component} from 'react';
import {Row, Col, Card, Badge, Container} from "reactstrap";

class PrescriptionHistory extends Component {
    render() {
        const prescriptionHistory = this.props.prescriptionHistory.medicationHistory.map(prescription => (
            <div style={{fontSize: '0.8rem'}} key={prescription.prescriptionNumber}>
                <Row>
                    <Col md="9"><span
                        style={{fontWeight: 'bolder'}}>{prescription.rxName} {" "} {prescription.strength} {" "}</span>
                        <span className="font-weight-bold text-muted">(Rx {prescription.prescriptionNumber})</span>
                    </Col>
                    <Col md="3">
                        <Badge style={{fontSize: '100%'}} className="text-center"
                               color="secondary ml-2">{prescription.rxStatus}</Badge>
                    </Col>
                </Row>
                <Row>
                    <Col md="6"><span className="font-weight-bold">NDC : </span>
                        <span className="text-muted font-weight-bold">
                        {prescription.ndcNumber}
                        </span>
                    </Col>
                    <Col md="6"><span className="font-weight-bold">Filled:</span>
                        <span className="text-muted font-weight-bold">
                        {prescription.dateFilled}
                        </span></Col>
                </Row>
                <Row>
                    <Col md="12"><span className="font-weight-bold">Directions :</span>
                        <span className="text-muted font-weight-bold">
                        {prescription.rxDirectionsToUse}
                        </span>
                    </Col>
                </Row>
                <Row>
                    <Col md="3"><span className="font-weight-bold">QTY : </span>
                        <span className="text-muted font-weight-bold">
                        {prescription.quantity}
                        </span>
                    </Col>
                    <Col md="4"><span className="font-weight-bold">Days Supply : </span>
                        <span className="text-muted font-weight-bold">
                        {prescription.daysSupply}
                        </span>
                    </Col>
                    <Col md="5"><span className="font-weight-bold">Prescriber : </span>
                        <span className="text-muted font-weight-bold">
                        {this.props.prescriberInfo.name}
                        </span>
                    </Col>
                </Row>
                <hr/>
            </div>
        ));
        return (
            <Container className="card-scroll">
                {prescriptionHistory}
            </Container>
        );
    }
}

export default PrescriptionHistory;
